import React, { useState } from 'react';
// import DropdownButton from 'react-bootstrap/DropdownButton';
// import Dropdown from 'react-bootstrap/Dropdown'
// import Button from 'react-bootstrap/Button'
import adData from '../../../json/icao-ad.json';
import reactDom from 'react-dom';

import { DropdownButton, Dropdown, Button, Alert } from 'react-bootstrap'

export default function MetarTAF() {


  const adList = adData.map((aerodromes) => {
    return aerodromes.military.map(military => {
      return (
        <Dropdown.Item
          as="button"
          eventKey={military.icao}
        >
          {military.icao}: {military.name}
        </Dropdown.Item>
      )
    }
    )
  }
  )

  const metarBasicUrl = "https://awiacja.imgw.pl/metarmil.php?airport="
  const [value, setValue] = useState('');
  const [rssUrl, setRssUrl] = useState("");
  const [items, setItems] = useState([]);

  const getMetar = async (e) => {
    e.preventDefault();
    const urlRegex = /(http|ftp|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?/;
    if (!urlRegex.test(rssUrl)) {
      return;
    }
    const res = await fetch(`https://api.allorigins.win/get?url=${rssUrl}`);
    const { contents } = await res.json();
    const feed = new window.DOMParser().parseFromString(contents, "text/xml");
    const items = feed.querySelectorAll("item");
    const feedItems = [...items].map((el) => ({
      link: el.querySelector("link").innerHTML,
      title: el.querySelector("title").innerHTML,
      description: el.querySelector("description").innerHTML
    }));
    setItems(feedItems);
    document.getElementById("loadMetar").hidden = true;
    document.getElementById("metarContainer").hidden = false;
  };

  const handleSelect = (e) => {
    setValue(e)
    setRssUrl(metarBasicUrl + e)
    document.getElementById("loadMetar").hidden = false;
    document.getElementById("metarContainer").hidden = true;
    // document.getElementById("milAdDropDown").title = "dasds";
  }

  return (
    <div className="adSelect">
      <form
        className="adSelect"
        onSubmit={getMetar}>
        <DropdownButton
          id="milAdDropDown"
          title="Wybierz lotnisko"
          variant="secondary"
          onSelect={handleSelect}
        >
          {adList}
        </DropdownButton>
      </form>
      <Alert hidden id="loadMetar" variant="info">Pobieram dane</Alert>

      {/* <Button hidden className="btn btn-light" type="submit">Pobieram dane</Button> */}

      <div id="metarContainer" className="metar">
        {items.map((item) => {
          return (
            <div >
              {item.description}
            </div>
          );
        })}
      </div>
    </div>
  )
}